import { signInWithPopup, AuthProvider, User } from "firebase/auth";
import { doc, setDoc } from 'firebase/firestore';
import { auth } from "../config/firebaseConfig";  // Adjust this path according to your configuration
import { CreateAccountApi, VerifyAccountApi } from "../apis/authServices";
import { getUserDetails } from "../apis/homeServices";
import { useUserStore } from "../store/userStore";
/**
 * Reusable function to sign in with a specified provider.
 * @param provider - The authentication provider for(Google, Apple, etc.)
 * * @param setIsAuthenticated - Function to update authentication state
 * @param navigate - Function to redirect to a specified path
 * @returns User details or error message
 */

  
export const signInWithProvider = async (
  provider: AuthProvider,
  setIsAuthenticated: (auth: boolean) => void,
  navigate: (path: string) => void,
  isSignup: boolean // New parameter to distinguish sign-up vs. sign-in
  ) => {

  try {
    const result = await signInWithPopup(auth, provider);
    console.log("result:", result); 
    const user = result.user;
    console.log("User details:", user);
// Check if user is new (sign-up)
const isNewUser = result.user.metadata.creationTime === result.user.metadata.lastSignInTime;
console.log(isNewUser, isSignup)

if (isSignup) {
  // Sign-up flow: Skip VerifyAccountApi, save new user data
  if (isNewUser) {
    console.log("CreateAccount api called ##################################################################################################################################################################################3t");
    await CreateAccountApi();
    navigate('/createAccount'); // Redirect to profile completion for username
  } else {
    navigate('/search'); // Existing user, treat as sign-in
  }
} else  {
    // Extract email
    const email = user.email;
    if (!email) {
      return "Error: Unable to retrieve email from provider.";
    }

    // Verify account status with VerifyAccountApi
    interface VerifyResponse {
      statusCode: number;
      message: string;
      statusId: number;
      statusName: string;
    }

    const verifyResponse = await VerifyAccountApi(email);
    console.log("VerifyAccount API Response:", verifyResponse);

    const statusId = verifyResponse?.statusId ?? null;
    console.log("Status ID:", statusId);

    switch (statusId) {
      case 1: // Inactive → Redirect to Create Account
        console.log("🔄 Email exists but inactive. Redirecting to Create Account...");
        navigate("/createAccount");
        return user; // Return user, as redirect is handled

      case 2: // Active → Proceed with authentication
       { console.log("Email active. Proceeding with sign-in...");
        setIsAuthenticated(true);
        
        // Fetch user details to get role and navigate accordingly
        try {
          const userDetails: any = await getUserDetails();
          console.log("User details fetched:", userDetails);
          
          // Store user details in userStore
          useUserStore.getState().setUsername(userDetails.userName);
          useUserStore.getState().setEmail(userDetails.email);
          useUserStore.getState().setUserRole(userDetails.role);
          useUserStore.getState().setReferralCode(userDetails.referralCode);
          
          // Navigate based on role
          if (userDetails.role === "admin") {
            navigate("/admin/dashboard");
          } else {
            navigate("/search");
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
          // Fallback to /search if user details fetch fails
          navigate("/search");
        }
        
        return user;
    }
      case 3: // Blocked
      case 4: // Deleted
        return `Error: ${verifyResponse.message}`;

      case null: // Email does not exist
        await CreateAccountApi();
        navigate("/createAccount");
        return "Error: This email does not belong to an account. Please use an existing email or sign up.";

      default:
        return "Error: Unexpected response from the server. Please try again.";

    }
  }
    
    
    
    
  } catch (error: any) {
    console.error("Error during sign-in:", error.message);
    return `Error: ${error.message || "Sign-in failed."}`;
  }
};
